module.exports = __webpack_public_path__ + "static/media/layer5M.61d40988.png";